export const cartRelaunchFr = {
  cart_relaunch: {
    title: 'Relance panier',
    description: 'Recuperez les paniers abandonnes avec des campagnes email automatisees',

    // Settings
    settings: 'Parametres',
    enabled: 'Active',
    disabled: 'Desactive',
    save_settings: 'Enregistrer',
    relaunch_intervals: 'Intervalles de relance',
    interval_1h: '1 heure apres abandon',
    interval_24h: '24 heures apres abandon',
    interval_48h: '48 heures apres abandon',

    // Analytics
    analytics: 'Statistiques',
    abandoned_carts: 'Paniers abandonnes',
    emails_sent: 'Emails envoyes',
    open_rate: "Taux d'ouverture",
    click_rate: 'Taux de clic',
    carts_restored: 'Paniers restaures',
    conversion_rate: 'Taux de conversion',
    potential_revenue: 'Revenu potentiel',
    recovered_revenue: 'Revenu recupere',
    links_clicked: 'Liens cliques',
    converted: 'Convertis',

    // Funnel
    recovery_funnel: 'Entonnoir de recuperation',

    // Table
    abandoned_carts_list: 'Paniers abandonnes',
    no_abandoned_carts: 'Aucun panier abandonne pour cet evenement',
    customer: 'Client',
    amount: 'Montant',
    abandoned_date: "Date d'abandon",
    status: 'Statut',
    restored: 'Restaure',
    pending: 'En attente',
    max_reached: 'Max atteint',
    showing_x_of_y: 'Affichage de {{shown}} sur {{total}}',

    // Errors
    error_loading: 'Erreur lors du chargement des donnees',
    error_saving: "Erreur lors de l'enregistrement",
  },
};
